import { Resource } from '__types__/index';
import { createUseOptimisticState } from 'v5/platform/react/useOptimisticState';
import { resourceEffectReducer } from './resource.effect.reducer';
import { ResourceEffect } from './resource.effect.types';

/**
 * Creates a resource-specific optimistic state hook.
 * This provides optimistic updates for resource operations while maintaining
 * compatibility with the existing v4 resource architecture.
 */
export const useOptimisticResource = createUseOptimisticState<
  Resource,
  ResourceEffect
>({
  reducer: resourceEffectReducer
});
